import { storage } from 'BASE/common/util/util.storage';
import AnnouncementComponent from '#BASE/components/annoucement/annoucement.component';

export default {
    mixins: [AnnouncementComponent],
    props: {
        dialog: Object
    },
    data: function () {
        return {
            IsOrderByDesc: true,
            Annoucements: [],
            Detail: {},
            TotalPages: 1,            // 總共有多少分頁
            AnnouncementsPerPage: 6,  // 多少篇公告分一頁
            CurrentPage: 1,           // 當前分頁
            ContentTitle: "",         // 公告內文標題
            EffectiveTime: 5,   //單位分鐘
            EnableTop: false,   //訊息置頂 (當從首頁跑馬燈或其它地方跳轉該公告頁時，對應的訊息是否置頂顯示)
            apiURL: "GetListWithReadMark",
        };
    },
    methods: {
        async getList() {
            let _this = this;
            _this.Annoucements = [];

            await _this.GetAnnouncements();

            // 根據公告量的多寡取得要幾個分頁
            _this.getPages();

            //網址有夾帶ID取網址的資訊
            if (_this.$route.params.id) {
                let _id = _this.$route.params.id;
                _this.getDetail(_id);
                _this.setTop(_id);
            }
            else if (_this.Annoucements[0]) {
                //如公告有東西，預選第一項目
                _this.setContentTitle(_this.Annoucements[0].ID);
                _this.getDetail(_this.Annoucements[0].ID);
            }
        },
        getPages() {
            let _this = this;
            _this.TotalPages = Math.ceil( _this.Annoucements.length / _this.AnnouncementsPerPage ); // Get a upward to its nearest integer 
        },
        setContent(announcement) {
            this.setContentTitle(announcement.ID);
            this.SetAnnouncementRead(announcement);
        },
        setContentTitle(id) {
            let _this = this;
            this.ContentTitle = "";
            $.each(_this.Annoucements, function (index, value) {
                if (value.ID == id) {
                    _this.ContentTitle = value.Title;
                }
            });
            // Scroll to Top
            $('#AnnouncementPage').scrollTop(0);
        },
        turnPageUp() {
            let _this = this;
            if ( _this.TotalPages > _this.CurrentPage ) {
                _this.CurrentPage = _this.CurrentPage + 1;
            }
        },
        turnPageDown() {
            let _this = this;
            if ( 1 < _this.CurrentPage ) {
                _this.CurrentPage = _this.CurrentPage - 1;
            }
        },
        jumpToPage(page) {
            let _this = this;
            _this.CurrentPage = page;
        },
        showAnnouncement(id, index){
            let _this = this;
            // 假如沒傳入參數  跳出列表中第一項公告
            if (!id) {
                if (_this.Annoucements[0]) {
                    _this.CurrentPage = 1;
                    _this.setContentTitle(_this.Annoucements[0].ID);
                    _this.getDetail(_this.Annoucements[0].ID);
                    _this.setTop(_this.Annoucements[0].ID);
                    _this.SetAnnouncementRead(_this.Annoucements[0]);
                }
            }
            else {
                // 根據公告的index除以每頁可顯示的最大數量，取下限整數再+1
                let page = Math.floor( index / _this.AnnouncementsPerPage ) +1;
                _this.CurrentPage = page;

                _this.setContentTitle(id);
                _this.getDetail(id);
                _this.setTop(id);
            }

            let _dialog = _this.$dialog.get('announcement');
            _dialog.show();
        },
        closeAnnouncement(){
            let _dialog = this.$dialog.get('announcement');
            _dialog.hide();
        }
    }
};